<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="全部替换"
      width="960px"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      本地替换影响到{{tableData.length}}个spu，请核对后点击确认，确认后将全部替换。
      <el-table 
        :data="tableData" 
        border 
        :height="390" 
        style="margin-top: 10px;"
      >
        <el-table-column label="SPU名称" prop="spuName"></el-table-column>
        <el-table-column label="SKU编码" prop="skuCode"></el-table-column>
        <el-table-column label="SKU名称" prop="skuName"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="onDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible','finalTableData', 'keyword', 'instead'],
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      
      this.$q.newProduct.editInformationAll({
        data: {
          modifyBefore: this.keyword,
          modifyAfter: this.instead,
          spuCodeList: this.tableData.map(v=>v.spuCode)
        }
      })
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('替换成功')
        }else{
          this.$message.error(res.message)
        }
      })
      .finally(_=>{
        this.updateVal();
        this.$emit('complete', null)
      })
    },
    /**
     * 列表搜索
     */
    init() {
      this.$q.newProduct.getInformationSpuList({params: {
        modifyBefore: this.keyword
      }})
      .then(res=>{
        this.tableData = res.data;
      })
    },
    /**
     * 删除
     */
    onDel(row) {
      this.tableData = this.tableData.filter(v=>v.spuCode !== row.spuCode)
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>